export function relocationPalletEpcValidate(pallet_epc_record){
    var result = true;

    result = validateLocation(pallet_epc_record.location);
    result = validateClient(pallet_epc_record.client);
    result = validateProducts(pallet_epc_record.products);

    return result;
}

function validateLocation(location) {
    return (typeof location === 'object' &&
      location !== null &&
      'id' in location &&
      'name' in location &&
      'text' in location)
}

function validateClient(client){
    return (typeof client === 'object' &&
      client !== null &&
      'id' in client &&
      'name' in client &&
      'rfid_by_product' in client)
}

function validateProducts(products) {
    return (
        Array.isArray(products) &&
            products.every(item => 
                typeof item === 'object' &&
                item !== null &&
                'detailed_stock_id' in item &&
                'sku' in item &&
                'text' in item &&
                'quantity' in item && 
                'epcs' in item && 
                Array.isArray(item.epcs)
            )
    )
}